import React from 'react'
import PropTypes from 'prop-types'
import { capitalize } from 'lodash'
import { ProfileField } from '../../../../../components/generic'
import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import { formatAddress } from '../../../../../common/utils'
import { ResidentProfileSectionWrapper } from '../../../components'

export default function TeamMemberProfilePersonal(props) {
  const { profile, teamMemberEnabled } = props

  const wrapperStyles = { marginTop: 24 }

  return (
    <ResidentProfileSectionWrapper
      color={colors.purple}
      icon="profile"
      style={wrapperStyles}
      title="Personal details"
      data-testid="team-member-profile-personal-section"
    >
      <div
        className="lmc-card"
        style={styles.contentContainer}
        data-testid="team-member-profile-personal-content"
      >
        {PERSONAL_INFO_FIELDS.map((field, i) => {
          if (!teamMemberEnabled && field.key === 'endDate') {
            return null
          }

          return (
            <ProfileField
              key={i}
              label={field.label}
              style={styles.field}
              value={getValue(field.key, profile)}
              data-testid={`team-member-profile-personal-${field.key}`}
            />
          )
        })}
      </div>
    </ResidentProfileSectionWrapper>
  )
}

const getValue = (key, profile) => {
  const value = profile[key]

  // hasAllergies === Yes or None known
  if (key === 'allergies' && profile.hasAllergies === 'None known') {
    return profile.hasAllergies
  }
  if (!value) return <span style={styles.noInfo}>No information entered</span>
  if (key === 'address') {
    return formatAddress(value)
  }
  if (key === 'dateOfBirth' || key === 'startDate' || key === 'endDate') {
    return dayjs(value).format('Do MMMM YYYY')
  }
  // Outputs the name in the correct format.
  if (key === 'emergencyContactName') {
    // Checks for an empty string/undefined in the name, and outputs 'No information entered' if
    // the string is empty/undefined.
    if (
      profile.emergencyContactName.first === '' ||
      !profile.emergencyContactName.first
    ) {
      return <span style={styles.noInfo}>No information entered</span>
    }
    return `${profile.emergencyContactName.first || ''} ${
      profile.emergencyContactName.last || ''
    }`
  }
  return capitalize(profile[key])
}

const PERSONAL_INFO_FIELDS = [
  {
    key: 'dateOfBirth',
    label: 'Date of Birth',
  },
  {
    key: 'address',
    label: 'Address',
  },
  {
    key: 'phoneNumber',
    label: 'Telephone',
  },
  {
    key: 'allergies',
    label: 'Allergies',
  },
  {
    key: 'startDate',
    label: 'Start Date',
  },
  {
    key: 'endDate',
    label: 'End Date',
  },
  {
    key: 'emergencyContactName',
    label: 'Emergency Contact ',
  },
  {
    key: 'emergencyContactRelation',
    label: 'Emergency Contact Relation',
  },
  {
    key: 'emergencyContactNumber',
    label: 'Emergency Contact Telephone',
  },
]

const styles = {
  field: {
    textAlign: 'left',
  },
  noInfo: {
    color: colors.black,
  },
  wrapper: {
    marginTop: '36px',
  },
}

TeamMemberProfilePersonal.propTypes = {
  features: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
}
